// src/store/historico-store.js
import axios from "axios";

export default {
  namespaced: true,
  state: {
    lista: [],
    perPage: 100,

    // Filtros (RCPLANO0)
    DESCRICAO: null,
    TIPO: null,                // 'CREDITO' | 'DEBITO' | 'COMPENSACAO' | 'ACOMPENSAR'
    CODIGO_COMPLETO: null,     // ex.: "1.1" | "2.21"
    STATUS: null,              // 'A' | 'I'

    // Seleção/paginação
    registroSelecionadoId: null, // SEQUENCIA
    paginaAtual: 1,
  },
  getters: {
    LISTA: s => s.lista,
    PER_PAGE: s => s.perPage,
    DESCRICAO: s => s.DESCRICAO,
    TIPO: s => s.TIPO,
    CODIGO_COMPLETO: s => s.CODIGO_COMPLETO,
    STATUS: s => s.STATUS,
    REGISTRO_SELECIONADO_ID: s => s.registroSelecionadoId,
    PAGINA_ATUAL: s => s.paginaAtual
  },
  mutations: {
    SET_LISTA: (s, p) => { s.lista = p || [] },
    SET_PER_PAGE: (s, p) => { s.perPage = Number(p) || 25 },
    SET_DESCRICAO: (s, p) => { s.DESCRICAO = p },
    SET_TIPO: (s, p) => { s.TIPO = p },
    SET_CODIGO_COMPLETO: (s, p) => { s.CODIGO_COMPLETO = p },
    SET_STATUS: (s, p) => { s.STATUS = p },
    SET_REGISTRO_SELECIONADO_ID: (s, p) => { s.registroSelecionadoId = p },
    SET_PAGINA_ATUAL: (s, p) => { s.paginaAtual = p || 1 },
    SET_LIMPAR: (s) => {
      s.lista = [];
      s.DESCRICAO = null;
      s.TIPO = null;
      s.CODIGO_COMPLETO = null;
      s.STATUS = null;
      s.registroSelecionadoId = null;
      s.paginaAtual = 1;
    },
    SET_LIMPAR_APENAS_FILTRO: (s) => {
      s.lista = [];
      s.paginaAtual = 1;
    }
  },
  actions: {
    GET_LISTA: async ({ commit, getters }) => {
      const filtros = {
        DESCRICAO: getters.DESCRICAO ?? null,
        TIPO: getters.TIPO ?? null,
        CODIGO_COMPLETO: getters.CODIGO_COMPLETO ?? null,
        STATUS: getters.STATUS ?? null
      };
      const { data, status } = await axios.post(`/api/protected/historico/pesquisar`, filtros);
      if (status === 200 || status === 201) {
        // Esperado do backend: SEQUENCIA, DESCRICAO, TIPO, STATUS,
        // CODIGO_COMPLETO, CODIGO_PLANO, CODIGO_UNICO, HISTORICO_PREDECESSOR_ID,
        // GRAU, CODIGO_DIGITO, AFETA_SALDO
        commit("SET_LISTA", data || []);
      }
      return { data, status };
    },

    POST_REGISTRO: async (_ctx, registro) => {
      const payload = { registro, login: window.localStorage.getItem('login') };
      return axios.post(`/api/protected/historico/post`, payload);
    },

    EDIT_REGISTRO: async (_ctx, { registro, operacao }) => {
      const payload = { registro, login: window.localStorage.getItem('login'), operacao: operacao || 'alt' };
      return axios.post(`/api/protected/historico/edit`, payload);
    },

    GET_BY_ID: async (_ctx, id) => {
      const { data } = await axios.get(`/api/protected/historico/getById/${id}`);
      return Array.isArray(data) && data.length ? data[0] : null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modulos/historico-store.js